import { Icon } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import './ChatIconButton.scss';

const ChatIconButton = ({ icon, onClick, disabled = false, size = 'large', variant = 'default', className = '', ariaLabel, ...rest }) => {
  const handleClick = (e) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  const buttonClasses = ['chat-icon-button', `chat-icon-button--${size}`, `chat-icon-button--${variant}`, disabled && 'chat-icon-button--disabled', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type="button" className={buttonClasses} onClick={handleClick} disabled={disabled} aria-label={ariaLabel || `${icon} button`} {...rest}>
      <Icon name={icon} size={size === 'small' ? 's' : 'default'} color={variant === 'error' ? 'red' : undefined} />
    </button>
  );
};

ChatIconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large']),
  variant: PropTypes.oneOf(['default', 'error']),
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default ChatIconButton;
